// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import mixins from './mixins'
import store from './store'
import Meta from 'vue-meta'
import { DatePicker, Pagination, Popover, Dialog, Loading, Popconfirm, Input, Message, Tooltip, Progress } from 'element-ui';
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import dayjs from 'dayjs'
import formatEmoji from "./directives/emoji"

Vue.directive('formatEmoji', formatEmoji)
function removeCookie(name) {
  document.cookie = name + "=;expires=-1;path=/";
}
function clearCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString()
    }
  }
}
const getTimeZoneString = () => {
  const timeZone = 0 - new Date().getTimezoneOffset() / 60;
  return `UTC${timeZone < 0 ? timeZone : `+${timeZone}`}`;
}
const timezone = getTimeZoneString()
axios.interceptors.request.use(async config => {
  config.headers['webClientType'] = 'web'
  config.headers['ClientType'] = 'web'
  if (timezone) {
    config.headers['timezone'] = timezone
  }
  return config
})
axios.interceptors.response.use(async response => {
  return response
}, (error) => {
  if (error.response.status == 401) {
    // removeCookie('token')
    clearCookie()
  }
})
$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('timezone', timezone);
  },
  error: function (response) {
    if (response.status == 401) {
      // removeCookie('token')
      clearCookie()
    }
  }
});
Vue.component(DatePicker.name, DatePicker);
Vue.component(Pagination.name, Pagination);
Vue.component(Popover.name, Popover);
Vue.component(Dialog.name, Dialog);
Vue.component(Popconfirm.name, Popconfirm)
Vue.component(Input.name, Input)
Vue.component(Message.name, Message)
Vue.component(Tooltip.name, Tooltip)
Vue.component(Progress.name, Progress)

Vue.use(Loading)
Vue.use(Meta)

Vue.prototype.$message = Message
Vue.prototype.$bus = new Vue()

const dateFormat = (timestamp, formatter) => {
  return timestamp ? dayjs(timestamp * 1000).format(formatter) : ''
}

Vue.prototype.$format = dateFormat
Vue.config.productionTip = false
Vue.mixin(mixins)
Vue.filter('dateFormat', dateFormat)

const inDebug = /debug=1/.test(location.href) || /dev-web/.test(location.href)
if (inDebug) {
  // new vConsole()
} else {
  window['console']['log'] = function() {};
  window['console']['info'] = function() {};
}

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")